<template>
	<div name="hres62e-popup" id="hres62e-popup" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
		  <div class="modal-content">
		    <div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		      <h4 class="modal-title">{{ labels['HRES62EC3']['10'] }}</h4>
		    </div>

		    <div class="modal-body detail detail-responsive">
					<div class="box-body">
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-4 control-label">{{ labels['HRES62EC3']['20'] }}</label>
		            <div class="col-md-6">
		              <div class="form-control readonly-field-color">{{ data.codleave }} - {{ data.desc_codleave }}</div>
		            </div>
		          </div>
		        </form>
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-4 control-label">{{ labels['HRES62EC3']['30'] }}</label>
		            <div class="col-md-6">
		              <div class="form-control readonly-field-color">{{ data.desc_flgchol }}</div>
		            </div>
		          </div>
		        </form>
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-4 control-label">{{ labels['HRES62EC3']['40'] }}</label>
		            <div class="col-md-6">
		              <textarea  class="form-control readonly-field-color" maxlength="600" v-model="data.condition" ></textarea> 
		            </div>
		          </div>
		        </form>					
					</div>
				</div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'hres62e-popup',
  data () {
    return {
      selectedRow: []
    }
  },
  props: [ 'labels', 'data' ]
}
</script>



// WEBPACK FOOTER //
// popup.vue?adc1cc6e